<template>
    <div class="section-heading">
        <h1 class="text-size4 font-bold leading-spc4 " :class=" titleclass" v-if="titlelink">
            <router-link :to="titlelink" class="text-secondary hover:text-primary">
                {{title}} <span class="font-light">{{stitle}}</span>
            </router-link>
        </h1>
        <h1 class="text-size4 font-bold leading-spc4 " :class=" titleclass" v-if="!titlelink">
            {{title}} <span class="font-light">{{stitle}}</span>
        </h1>
        <p class="text-size5 tracking-spc2 font-medium leading-spc3 text-paragraph" :class=" descclass ">
            <strong class="font-bold" v-if="bolddesc">{{bolddesc}}</strong> {{desc}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "SectionHeadings",
        props: [
            'title',
            'titlelink',
            'titleclass',
            'stitle',
            'bolddesc',
            'desc',
            'descclass'
        ]
    }
</script>

<style scoped>

</style>